import { z } from 'zod'

/** Empty string is allowed; non-empty values must be a valid email. */
export const optionalEmail = z
  .union([z.literal(''), z.string().email('Enter a valid email')])
  .optional()
  .transform((v) => (v === '' || v === undefined ? undefined : v))
